import { links } from "./links";
import MainModulePage from "./page/main-module-page";

export default [
  {
    routeProps: {
      path: [links.home],
      exact: true,
      component: MainModulePage,
    },
    name: "main module",
  },
];
